var link_viewer_default = {
  "fontElementMap": "JQYxx",
  "link": "FMJXK",
  "linkInEditor": "_9pCm-",
  "linkInViewer": "_6h8tE",
  "toolbarUrlContainer": "-bqak",
  "toolbarUrl": "Jvuk3",
  "toolbarUrlAnchor": "SEQBF"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
